"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('weibo', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M12.5616 16.411C9.21739 19.6609 2.16299 29.1461 7.36228 35.9318C12.5616 42.7174 27.2819 40.0999 33.3587 35.3194C39.4356 30.5388 38.8357 27.5849 37.5182 26.2834C36.2006 24.9818 32.3553 26.2971 31.279 24.5261C30.2027 22.7551 33.1954 18.3311 30.645 16.9312C28.0945 15.5313 23.6905 20.5811 21.7012 19.269C19.712 17.9569 23.8904 13.6729 21.7012 12.4385C19.5121 11.204 15.9058 13.1611 12.5616 16.411Z",
    fill: props.outFillColor,
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M43.3785 16.5159C43.1432 13.3849 41.7988 10.5632 39.7369 8.44283C37.7244 6.37317 35.0285 4.97156 32.0134 4.60236",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M37.2919 16.9312C37.1627 15.2915 36.4247 13.8138 35.2928 12.7033C34.188 11.6195 32.7079 10.8854 31.0527 10.6921",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }));
});

exports.default = _default;